<div class="container-fluid custom-container">
  <div class="row">
    <div class="col-6">
      <app-add-template-button></app-add-template-button>
      <app-website-preview-button></app-website-preview-button>
    </div>
  </div>
  <app-microsites-subheader></app-microsites-subheader>
</div>